// extracted by mini-css-extract-plugin
export default {"skillDot":"selfSkills_skillDot__edgZf"};